import { NgTemplateOutlet } from '@angular/common';
import type { SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

import { SelectOfferPlacementComponent } from '../../../misc/select-offer-placement/select-offer-placement.component';
import type { DynamicPlacementInputConfig, Placement } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class PlacementInput extends DynamicFormInput<DynamicPlacementInputConfig> {
  public isHidden(): boolean {
    return (
      super.isHidden() ||
      (!this.config.required && !!this.config.hideIfEmpty && !this.config.placements.length)
    );
  }
}

@Component({
  selector: 'rti-placement-input',
  templateUrl: './placement-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectOfferPlacementComponent, NgTemplateOutlet, TranslatePipe],
})
export class PlacementInputComponent {
  public readonly input = input<PlacementInput>(undefined!);

  public placements: Placement[];

  public ngOnChanges(changes: SimpleChanges): void {
    if ('input' in changes) {
      this.placements = changes.input.currentValue.config.placements;
    }
  }

  public get selectedOfferAndLocationIds(): {
    offerId: number;
    locationId: number | null;
  } | null {
    return this.input().control.value;
  }

  public selectedOfferAndLocationIdsUpdated(selectedIds: {
    offerId: number;
    locationId: number | null;
  }): void {
    this.input().control.setValue(selectedIds);
  }
}
